import productsRatingResolve from "./productsRating.resolve";
export default function routes($stateProvider) {
	$stateProvider.state("productsRatingPage", {
		url: "/productsRating/?offset&order&name",
		template: require("./productsRating.html"),
		resolve: {
			...productsRatingResolve,
			loggedIn: [
				"User",
				function(User) {
					return User.requireLogin();
				}
			],
			brand: [
				"Brand",
				function(Brand) {
					return Brand.get();
				}
			],
			ratingsInfoLoader: [
				"Product",
				"offset",
				"order",
				"name",
				function(Product, offset, order, name) {
					return _ =>

						Product.all({
							offset,
							order,
							name
						});
				}
			],
			ratingsInfo: [
				"ratingsInfoLoader",
				function(ratingsInfoLoader) {
					return ratingsInfoLoader();
				}
			]
		},
		controller: "ProductsRatingController",
		controllerAs: "productsRating"
	});

}

routes.$inject = ["$stateProvider"];



// WEBPACK FOOTER //
// ./src/page/productsRating/productsRating.routes.js